import { UserOrGroupModel } from '../_models/DAL/UserOrGroup.model';
import { PowerBiObjectModel } from "../_models/DAL/PowerBiObject.model";

export const PBIO_Helper = {
  findRoleInPBIO(pbio: PowerBiObjectModel ,role:string) {
    return  pbio.roles.find(o=> o.theRole === role)
  },
  defineRoleIsPBIO(pbio: PowerBiObjectModel,role:string):boolean {
    return this.findRoleInPBIO(pbio,role) != undefined;
  },
  clearNewFlags (userOrGroups:UserOrGroupModel[] ) {
    userOrGroups.forEach(userOrGroup => {
      userOrGroup.isNew = false;
    });
  }

};
